
import { settingStore, menuStore } from '@/stores/index'
import Component from 'vue-class-component';
import Vue from 'vue'
@Component
export default class TabBar extends Vue{
    store = settingStore();
    menu = menuStore();
    activeName = this.menu.activeName;
    handleClose(name: string) {
        switch (name) {
            case 'left':
                this.menu.RemoveLeft();
                break;
            case 'right':
                this.menu.RemoveRight();
                break;
            case 'other':
                this.menu.RemoveOthers();
                break;
            case 'all':
                this.menu.RemoveALL();
                break;
        }
    }
    TabClicked(tab: string) {
        const current = this.$route.name;
        if (current != tab){
            this.menu.Change(tab);

        }
            
    };

    TabRemoved(tab: number) {
        return new Promise(resolve => {
            this.menu.Remove(tab);
        })
    }
}
